var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8787 3.70705C15.0503 2.53548 16.9497 2.53547 18.1213 3.70705L20.2929 5.87862C21.4645 7.0502 21.4645 8.94969 20.2929 10.1213L10.2929 20.1213C9.73028 20.6839 8.96722 20.9999 8.17157 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999V15.8284C3 15.0327 3.31607 14.2697 3.87868 13.7071L13.8787 3.70705ZM16.7071 5.12126C16.3166 4.73074 15.6834 4.73074 15.2929 5.12126L14.4142 5.99994L18 9.58573L18.8787 8.70705C19.2692 8.31653 19.2692 7.68336 18.8787 7.29284L16.7071 5.12126ZM16.5858 10.9999L13 7.41416L7.41421 12.9999L11 16.5857L16.5858 10.9999ZM9.58579 17.9999L6 14.4142L5.29289 15.1213C5.10536 15.3088 5 15.5632 5 15.8284V17.0857L6.91421 18.9999H8.17157C8.43679 18.9999 8.69114 18.8946 8.87868 18.707L9.58579 17.9999Z",
    fill: "var(--grey-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ee76df3fc0c41c6b9eda287bdb2693bc.svg";
export { ForwardRef as ReactComponent };